import React, {useEffect} from 'react';
import { useDispatch, useSelector } from "react-redux";
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logoutImg from 'assets/img/icons/spot-illustrations/45.png';

import { logoutUser } from "../../api/authentication";
import { removeUser } from "../../redux/actions/user";

import {deleteCookieCredentials} from '../../util/helper';

const LogoutContent = ({ layout, titleTag: TitleTag }) => {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

    useEffect(() => {
      
        async function logout() {
          const res = await logoutUser(user);
          const {code} = res;

          if (code === 200) {
            deleteCookieCredentials();
            dispatch(removeUser()); 
          }
        }

        logout();
    }, []);

  return (
    <>
      <img
        className="d-block mx-auto mb-4"
        src={logoutImg}
        alt="shield"
        width={100}
      />
      <TitleTag>See you again!</TitleTag>
      <p>
        Thanks for using Fnotrader. You are <br className="d-none d-sm-block" />
        now successfully signed out.
      </p>
      <Button
        as={Link}
        color="primary"
        size="sm"
        className="mt-3"
        to={`/authentication/login`}
      >
        <FontAwesomeIcon
          icon="chevron-left"
          transform="shrink-4 down-1"
          className="me-1"
        />
        Return to Login
      </Button>
    </>
  );
};

LogoutContent.propTypes = {
  layout: PropTypes.string,
  titleTag: PropTypes.string
};

LogoutContent.defaultProps = {
  layout: 'simple',
  titleTag: 'h4'
};

export default LogoutContent;
